module.exports = __webpack_public_path__ + "media/images/503-2539542140c8ded36852ed648b7b85cb.svg";